export default {
    Login: '登录',
    LoginEmpty: '登 录',
    ToLogin: '去登录',
    WelcomeTo: '欢迎来到',
    GaoDengMRT: '高登捷运',
    TFICompany: '国际站平台，财税，国际物流运输为一体的供应链公司',
    TeamServiceChoice : '专业的团队，优质的服务，您最佳的选择！',
    Home: '主页',
    Service: '服务',
    Provide: '提供',
    AboutUs: '关于我们',
    QuotationInquiry: '报价查询',
    Regist: '注册',
    RegistEmpty: '注 册',
    ToRegist: '去注册',
    EenterUserName: '请输入用户名',
    EenterCompanyName: '请输入公司名称',
    EenterPassword: '请输入密码',
    EenterCode: '请输入验证码',
    GraphicsCode: '图形验证码',
    NoAccount: '没有账号',
    ExistingAccounts: '已有账号',
    WeProvide: '我们提供: 一流的供应链服务',
    Profile: '简介',
    Team: '团队',
    Address: '地址',
    FastLink: '快捷链接',
    CommercialService: '商业服务',
    SenseOfValue: '价值观',
    RegisteredInLonggang: '我们成立于2011年，目前4家分公司，是一家提供全方位服务的货运代理和物流公司。我们与世界各地的企业合作，在全球范围内提供创新的物流解决方案。我们的灵活性、个性化/量身定制的服务和敬业的团队是我们获得高水平客户满意度和忠诚度的关键。欢迎咨询、加入我们。',
    ThoughtHonestyService: '思想、诚信和服务是我们价值的“金三角”',
    InternationalPlatform: '国际站平台诊断',
    NternationalLogistics: '国际物流',
    FiscalAndTaxationServices: '财税服务',
    YushangSalon: '育商沙龙',
    Headquarters: '深圳市高登捷运国际货运代理有限公司 (总公司)',
    HeadquartersAddress: '深圳市龙岗区龙城街道龙翔大道与建设路交汇处珠江',
    JiangxiBranch: '江西泰格尔国际货运代理有限公司 (江西分公司)',
    JiangxiBranchAddress: '南昌市红谷中大道1368号鼎峰中央AB 座1105-1110室',
    NanningBranch: '深圳市高登捷运国际货运代理有限公司 (南宁分公司)',
    NanningBranchAddress: '广西南宁市青秀区金湖路63号金源CBD现代城2333-2337',
    DongguanBranch: '东莞市高登捷运国际货运代理有限公司 (东莞分公司)',
    DongguanBranchAddress: '东莞市东城区东莞大道11号台商大厦2308',
    SenseOfValueText: '诚信是我们做事做人的准则。思想的高度决定服务的深度。我们追求的是服务的专业化。全球性的服务网络造就完善的服务体系，一切只为您！',
    RecordNumber: '备案号',
    RecordNumberText: '粤ICP备13013856号',
    SelectingServing: '选择服务',
    PswGreaterSix: '密码长度大于六位',
    CodeLengthFour: '验证码长度四位',
    AlibabaSupplyChainServices: '阿里巴巴供应链服务',
    AlibabaSupplyChainServicesIntroduct: '2015年入驻阿里拍档项目，协助阿里国际站平台客人接单，融资，网站诊断，物流运输服务。',
    InternationLogisticsTransporation: '国际物流运输',
    InternationLogisticsTransporationIntroduct: '2011年公司成立以来，配合客人出口物流运输安排，整柜，散货，空运，快递，专线运输以及安排拖车，报关，产地证，保险等服务。',
    InternationLogisticsTransporationIntroduct2: '2011年公司成立以来，配合客人出口物流运输安排，整柜，散货，空运，快递，专线运输以及安排拖车，报关，产地证，保险等服务。',
    JointProfessional: '合规定制，专业税筹',
    JointProfessionalIntroduct: '结合企业经营实际情况，综合运用国家税收优惠政策，为企业及个人实现合法合规节税法税互通，战略设计：帮助企业搭建股权架构、再造内控流程、优化交易结构，做好顶层设计，实现长远发展。',
    InternationalStationPlatform: '国际站平台',
    InternationalStationPlatformIntroduct: '优秀的国际站平台诊断， 帮助你完善国际站平台产品铺货，产品设置，运费模版设置，财税设置',
    InternationalLogistics: '国际物流',
    InternationalLogisticsIntroduct: '专业的物流服务团队，解决你物流服务痛点，订舱，拖车，报关，产地证，保险一条龙服务',
    FiscalAndTaxationServices: '财税服务',
    FiscalAndTaxationServicesIntroduct: '阿里认证财税服务，解决退税的专业问题，高质量的服务解决退税难的痛点',
    YushangSalon: '育商沙龙',
    YushangSalonIntroduct: '60平米培训场地，定期平台知识，物流知识，财税知识培训。 解决链路闭环，也为客户培训专业人才',
    InternationalDiagnosticReservation: '国际站诊断预约',
    WholeContainerShipping: '整柜海运',
    LandTransportContainer: '陆运拖柜',
    BulkShipping: '散货海运',
    InternationalExpress: '国际快递',
    FiscalAndTaxationServices: '财税服务',
    heading: '标题',
    PleaseEnter: '请输入',
    PleaseSelect: '请选择',
    SelectDate: '选择日期',
    ThisPort: '此港口',
    WarehouseExplosion: '爆仓',
    Or: '或者',
    OffPort: '偏港',
    Please: '请',
    Offline: '线下',
    IndividualPriceConfirmation: '单独确认价格',
    ContactUs: '联系我们',
    NoSearchData: '暂无搜索数据',
    EssentialInformation: '基本信息',
    ChargeWeight: '收费重',
    Volume: '体积',
    NumberOfPieces: '件数',
    Box: '箱',
    GoodsType: '货物类型',
    Invoice: '发票',
    WhetherToSupplement: '是否后补',
    Yes: '是',
    No: '否',
    ClickUpload: '点击上传',
    Sensitive: '敏感品',
    GoodsDetails: '货物详情',
    NeedOffline: '需要线下单独确认',
    EnterGoodsDetails: '请输入货物详情',
    DepartureCost: '起运港费用',
    CostName: '费用名称',
    Currency: '币种',
    Cost: '费用',
    Subtotal: '小计',
    Remarks: '备注',
    DestinationCost: '目的港费用',
    ShippingCosts: '海运费用',
    VolumeGrossWeight: '体积重和毛重取大值计算',
    ActualConfirmed: '实际费用以出货前确认为准',
    ConfirmOrder: '确认下单',
    Ordinary: '普通',
    NoLogin: '您还没有登录, 现在去登录?',
    Prompt: '提示',
    OK: '确定',
    Cancel: '取消',
    cargoTypeCanNotBeEmpty: '货物类型不能为空！',
    GoodsDetailsCannotBeEmpty: '货物详情不能为空！',
    InvoiceCannotBeEmpty: '发票不能为空！',
    SuccessfulOrder: '下单成功！',
    SuccessfulUpload: '上传成功！',
    UploadFailed: '上传失败！',
    UploadLimit10: '上传头像图片大小不能超过 10MB!',
    Destinatio: '目的港',
    EnterDestinatio: '请选择目的港',
    PackagingType: '包装类型',
    ChoosePackagingType: '请选择包装类型',
    TotalGrossWeight: '总毛重',
    EnterGrossWeight: '请输入毛重',
    Long: '长',
    EnterLong: '请输入长',
    Wide: '宽',
    EnterWide: '请输入宽',
    High: '高',
    EnterHigh: '请输入高',
    NumberPieces: '件数',
    EnterNumber: '请输入件数',
    SelectGoodsType: '请选择货物类型',
    Type: '类型',
    SearchQuote: '搜索报价',
    NoHistorical: '暂无历史搜索数据',
    DestinationName: '区域名称',
    DestinationCode: '区域代码',
    RouteCode: '指定路线',
    RouteName: '路线名称',
    TotalCostCNY: '总费用CNY',
    UnitPriceCNY: '单价CNY',
    FreightCNY: '运费CNY',
    Surcharge: '附加费',
    VolumeNumber: '材积除以数',
    DisableGoods: '禁用货物类型',
    ExtractionAging: '提取时效',
    WorkingDay: '个工作日',
    IndateBegin: '生效时间',
    Descriptions: '备注',
    Operation: '操作',
    
    BusinessNumber: '业务单号',
    OrderState: '下单状态',
    EnterBusinessNumber: '请输入业务单号',
    SelectOrderState: '请选择下单状态',
    SearchOrder: '搜索订单',
    Determined: '待定',
    Cost: '费用',
    TransportMode: '转运方式',
    Voyage: '航程',
    Time: '时间',
    OrderNumber: '订单号',
    Direct: '直达',
    Transshipment: '转运',
    Day: '天',
    CreateTime: '创建时间',
    NextOrderTime: '下单时间',
    All: '全部',
    Submitted: '已提交',
    Ordered: '已下单',
    SelectStartingPort: '请选择起始港',
    SelectDestinationPort: '请选择目的港',
    SearchFreight: '搜索运价',
    HistoricalSearch: '历史搜索',
    NoHistoricalSearchData: '暂无历史搜索数据',
    StartingPort: '起始港',
    DestinationPort: '目的港',
    Weight: '重量',
    Volume: '体积',
    EnterWeight: '请输入重量',
    EnterVolume: '请输入体积',
    DeparturePort: '起运港',
    ClosingDate: '截关日期',
    DateOfShipment: '开船日期',
    DurationOfValidity: '有效期',
    SeaFreight: '海运费',
    Freight: '运费',
    ViewDetail: '查看详情',
    ClickSearchPriceData: '点击搜索报价搜索数据',
    NoteBelow: '下单须知',
    SpellStraight: '直拼',
    StartingPortNotEmpty: '起始港不能为空！',
    DestinationPortNotEmpty: '目的港不能为空！',
    WeightvolumeGreaterThan0: '重量和体积需有一个大于0！',
    BasicInformation: '基本信息',
    ShipCompany: '船公司',
    TransitPort: '中转港',
    BookingInstructions: '订舱须知',
    Nothing: '暂无',
    ValueAddedServices: '增值服务',
    DeparturePortCost: '起运港费用',
    CostName: '费用名称',
    Currency: '币种',
    Subtotal: '小计',
    DestinationPortCost: '目的港费用',
    OceanFreight: '海运费用',
    NotIncludeOtherBoxesCost: '不包含其他箱型的部分费用',
    ActualCostsConfirmedBeforeShipment: '实际费用以出货前确认为准',
    ConfirmShipment: '确认出运',
    NotLogged: '您还没有登录, 现在去登录?',
    Prompt: '提示',
    OK: '确定',
    Cancel: '取消',
    SuccessfulShipment: '出运成功',
    BusinessInformation: '业务信息',
    ConfirmOrder: '确认下单',
    EnterDelegateUnit: '请输入委托单位',
    EnterSettlementUnit: '请输入结算单位',
    EnterBillLading: '请输入提单方式',
    ChooseBoxQuantity: '请选择箱量',
    EnterShipper: '请输入发货人',
    EnterConsignee: '请输入收货人',
    EnterNotifier: '请输入通知人',
    EnterMark: '请输入唛头',
    EnterGoodsDescription: '请输入货物描述',
    EnterBillLadingName: '请输入提单品名',
    EnterDestination: '请输入目的地',
    EnterEnterBillLadingNotes: '请输入提单备注',
    EnterEnterBillLadingNotesNotPrint: '请输入提单备注/不打印',
    DelegateNotes: '委托备注',
    Shipper: '发货人',
    Consignee: '收货人',
    Informer: '通知人',
    Mark: '唛头',
    CargoDescription: '货物描述',
    BillLadingName: '提单品名',
    BillLadingNotes: '提单备注',
    SuccessfulUpload: '上传成功！',
    UploadFailed: '上传失败！',
    UploadImageFormatPDF: '上传头像图片只能是 PDF 格式!',
    UploadImageFormatSize: '上传头像图片大小不能超过 10MB!',
    SuccessfulOrder: '下单成功！',
    ThereAreAlsoUnfilledItems: '还有未填写的必填项！',
    SailingDate: '开航日期',
    SelectSailingDate: '请选择开航日期',
    SelectShippingCompany: '请选择船公司',
    SelectTransportMode: '请选择转运方式',
    ShippingDate: '船期',
    Section: '截',
    Open: '开',
    ShippingSpaceStatus: '舱位状态',
    ContactUs: '联系我们',
    NoOrdersAllowed: '不允许下单!',
    ShippingSpace: '舱位',
    CabinetType: '柜型',
    OtherBoxType: '其他箱型',
    SingleTicketBox: '单票/箱',
    ConfirmPriceOffline: '请线下单独确认价格!',
    Carton: '纸箱',
    WoodenCase: '木箱',
    CardBoard: '卡板',
    Express: '快递',
    DedicatedLine: '专线',
    SelectDestinationPortAndSearchAgain: '请选择目的港，然后再搜索！',
    SoFileUpload: 'SO文件上传',
    OnlyJpgPng: '只能上传jpg/png文件，且不超过500kb',
    Quantity: '数量',
    EnterCabinetDetailedAddress: '请输入装柜详细地址',
    EnterCabinetInstallationTime: '请输入装柜时间',
    EnterContact: '请输入联系人',
    EnterContactInformation: '请输入联系方式',
    EnterContainerReturnDock: '请输入还柜码头',
    SelectTheTransportationTerms: '请选择运输条款',
    CabinetDetailedAddress: '装柜详细地址',
    CabinetInstallationTime: '装柜时间',
    Contact: '联系人',
    ContactInformation: '联系方式',
    ContainerReturnDock: '还柜码头',
    TransportationTerms: '运输条款',
    WhetherArrangeClearance: '是否要安排过关',
    WhetherArrangeWeighing: '是否安排过磅',
    LoginUseService: '请先登录！方可使用服务',
    AccountLoginExpiredOrLoggedInWhere: '当前账号登录过期或已在它处登录！',
    Monday: '周一',
    Tuesday: '周二',
    Wednesday: '周三',
    Thursday: '周四',
    Friday: '周五',
    Saturday: '周六',
    Sunday: '周七',
    Normal: '正常',
    Nervous: '紧张',
    PositionExplosion: '爆仓',
    SeaFullContainer: '海运出口整箱',
    LandFullContainer: '陆运出口整箱',
    SeaFreightExportLCL: '海运出口拼箱',
    ExpressQuotationQuery: '快递报价查询',
    LogOut: '退出',
    TruckCosts: '拖车费用',
    EnterContainerAddress: '请输入装柜地址',
    EnterWharf: '请输入码头',
    ContainerAddress: '装柜地址',
    Wharf: '码头',
    ContainerAddressCannotEmpty: '装柜地址不能为空！',
    WharfCannotEmpty: '码头不能为空！',
    ContactWay: '咨询联系方式',
    OtherService: '我们的服务：1，进、出口物流服务、海运整箱、拼箱服务、空运服务、陆运运输。2，报关、清关代理服务各类出口单证制作。 3，仓储服务。 4，拖车服务。 5，门到门一条龙服务。 6，危险品运输服务。 7，冻柜运输服务8，项目货物运输服务'
}


// WEBPACK FOOTER //
// ./src/lang/zh.js